import { createRef, h, Fragment } from 'preact';
import { useState, useEffect } from 'preact/hooks';
import clsx from 'clsx';
import Image from '../utils/image';
import IconCaretDown from '../utils/icon/caret-down.svg';
import Menu from './v-menu';


export default ({
  stickThreshold,
  logo,
  logoLink,
  menu,
  ctaText,
  ctaUrl,
}) => {
  const selfRef = createRef(null);
  const [isStickyActive, setIsStickyActive] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const headerDom = document.querySelector('[data-section="header"]');
  const headerHeight = headerDom?.offsetHeight || 133;
  
  const scrollHandler = () => {
    if (window.pageYOffset >= (stickThreshold || headerHeight)) {
      setIsStickyActive(true);
    } else {
      setIsStickyActive(false);
    }
  };

  let animationFrameId = null;
  const throttledScrollHandler = () => {
    if (animationFrameId) {
      cancelAnimationFrame(animationFrameId);
    }

    animationFrameId = requestAnimationFrame(scrollHandler);
  };

  useEffect(() => {
    scrollHandler();
    window.addEventListener('scroll', throttledScrollHandler);

    return () => {
      window.removeEventListener('scroll', throttledScrollHandler);
      cancelAnimationFrame(animationFrameId);
    };
  }, []);

  const handleMenuToggle = () => {
    setIsMenuOpen(!isMenuOpen);
  }

  return (
    <div
      ref={selfRef}
      className={clsx(
        'fixed top-0 inset-x-0',
        'bg-v-dark-overlay backdrop-blur-[20px] px-[15px] laptop:px-10 py-[19px]',
        'flex items-center justify-between laptop:gap-x-10',
        'flex-wrap laptop:flex-nowrap',
        'transition-all ease-in duration-100',
        isStickyActive ? 'opacity-1' : 'opacity-0 pointer-events-none',
      )}
    >
      {logo && (logoLink
          ? <a className='relative z-10 inline-flex items-center self-stretch link-unstyled' href={logoLink}>
            <Image src={logo} />
          </a> 
          : <Image src={logo} />
      )}
      {(menu || ctaText && ctaUrl) && (
        <>
          <button
            className='flex items-center justify-end laptop:hidden absolute inset-x-0 top-0 h-[50px] pr-[15px]'
            onClick={handleMenuToggle}
            aria-label={`${ isMenuOpen ? 'Close' : 'Open' } menu`}
          >
            <IconCaretDown className={clsx(
              'laptop:hidden',
              'size-3 [&_path]:!stroke-white',
              'transition-transform duration-200 ease-in-out',
              isMenuOpen && 'rotate-180',
            )}/>
          </button>
          <div className={clsx(
            'flex flex-col gap-y-5 w-full order-last',
            'transition-all duration-200 ease-in-out overflow-hidden',
            isMenuOpen ? 'max-h-screen' : 'max-h-0',
            'laptop:!flex laptop:!max-h-screen laptop:flex-row laptop:items-center laptop:justify-between laptop:gap-x-10', 
            'laptop:grow laptop:w-auto',
          )}>
            {menu && 
              <div className='pt-[26px] laptop:pt-0'>
                <Menu menu={menu} />
              </div>
            }
            {ctaText && ctaUrl && (
              <a className='btn-primary-stroke-inverse link-unstyled laptop:w-auto min-w-[128px]' href={ctaUrl}>{ ctaText }</a>
            )}
          </div>
        </>
      )}
    </div>
  )
}